import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
@Component({
  selector: 'app-my-aha-anonymous',
  templateUrl: './my-aha-anonymous.component.html',
  styleUrls: ['./my-aha-anonymous.component.scss'],
})
export class MyAhaAnonymousComponent implements OnInit {
  constructor(
    private router: Router,
    private readonly navService: NavigationLibraryService,
    private readonly dataService: DataService
  ) {}
  appVersion: string = null;

  ngOnInit(): void {
    this.appVersion = `${window.appVersion}(${window.buildVersion})`;
    if (this.dataService.isAnonyLinkTvClicked) {
      this.navService.focusContainer('button-container ', true, 0);
      this.dataService.isAnonyLinkTvClicked = false;
    } else if (this.dataService.isAnonySettingsClicked) {
      this.navService.focusContainer('button-container ', true, 1);
      this.dataService.isAnonySettingsClicked = false;
    } else {
      this.navService.focusContainer('button-container ', true, 0);
      this.dataService.isAnonyLinkTvClicked = false;
      this.dataService.isAnonySettingsClicked = false;
    }
  }

  onLinkTvClick(): void {
    this.dataService.isAnonyLinkTvClicked = true;
    this.router.navigate(['/link-tv']);
  }

  onArrowLeft(): void {
    this.dataService.emitVerticalMenuEvent({
      action: 'open',
    });
  }
}
